import React from 'react'

export default function Wrapper({ ...props }) {
  return (
    <div
      className={`flex border-b border-grey-400 h-12  hover:bg-primary-lightGreen pl-6 pr-4 ${props.className}`}
      {...props}
    >
      {props.children}
    </div>
  )
}
